<tt-page class="col-xs-12 col-md-6 sp-0" *ngIf="!!setting">
    <tt-card>
        <form class="form-horizontal sp-0" name="formFindPerson" novalidate (ngSubmit)="searchItems()" method="get" role="form">
            <tt-input ttRememberId="w_findperson.searchtext" ttLabel="searchtext" ttFocus="false" [(ttModel)]="setting.searchtext" (ttOnBlur)="onBlur('searchtext')" (ttModelChange)="onChanged($event, 'searchtext')" [ttButtons]="searchTextButtons"></tt-input>
        </form>
    </tt-card>

    <tt-list [ttData]="itemsListFindPersons"></tt-list>
</tt-page>
